import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { LLCFunctions } from '@functions/llc.service';
import { ClipboardService } from '@services/clipboard/clipboard.service';

@Component({
	selector: 'app-llc-resources',
	templateUrl: './llc-resources.component.html',
	standalone: false,
})
export class LlcResourcesComponent implements OnInit {
	public data;

	constructor(
		private llcFunctions: LLCFunctions,
		private clipboardService: ClipboardService,
	) {}

	ngOnInit(): void {
		this.llcFunctions.getResource().subscribe((res) => {
			this.data = res;
		});
	}

	copyJSON() {
		this.clipboardService.copyText(
			JSON.stringify(this.data.financialInstitutions, null, 2),
		);
	}
}
